module.exports = __webpack_public_path__ + "img/unstable-magic-spike.56eab717.jpg";